// components/payments/PaymentTabs.tsx
import React from "react";
import { ArrowDownUp, Wallet } from "lucide-react";

interface PaymentTabsProps {
  activeTab: "transactions" | "payouts";
  onTabChange: (tab: "transactions" | "payouts") => void;
}

const PaymentTabs: React.FC<PaymentTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const tabs = [
    {
      id: "transactions" as const,
      label: "Transactions",
      icon: ArrowDownUp,
      count: 0,
    },
    {
      id: "payouts" as const,
      label: "Payouts",
      icon: Wallet,
      count: 0,
    },
  ];

  return (
    <div className="inline-flex items-center p-1 bg-gray-100 rounded-xl">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
            activeTab === tab.id
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <tab.icon className="w-4 h-4" />
          {tab.label}
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-medium ${
              activeTab === tab.id
                ? "bg-[#8B52FF]/10 text-[#8B52FF]"
                : "bg-gray-200 text-gray-500"
            }`}
          >
            {tab.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default PaymentTabs;
